import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";

import { SeccionesXSemestre } from '../../funciones/functionEstadistica';

class AlumnosSeccion extends Component {
    state = {
        datosC: <div align = "center" className="text-danger"><i className="fa fa-spinner fa-spin"></i> Cargando datos</div>,
        datosT: "",
    }

    componentDidMount = () => {
        SeccionesXSemestre(this.props.datos.id, (resp) => {
            let porcentajeM = (resp.M * 100) / resp.Total;
            let porcentajeF = (resp.F * 100) / resp.Total;

            let contenido = <Row>
                                <Col md = {12}>
                                    <div className="custom-alert-warning" style={{fontSize: 10}}>Datos estadísticos de <strong>{this.props.datos.materia_name}</strong></div>
                                </Col>
                                <Col md = {6} className="custom-mt-10">
                                    <div style={{fontSize:10}} className="text-danger">Femenino <span className="text-muted"><strong>({resp.F})</strong> estudiantes</span></div>
                                    <div className="progress">
                                        <div className="progress-bar" role="progressbar" aria-valuenow="70"
                                            aria-valuemin="0" aria-valuemax="100" style={{width: `${Math.round(porcentajeF)}%`, backgroundColor:"#A0555C"}}>
                                            {Math.round(porcentajeF)}%
                                        </div>
                                    </div>
                                </Col>
                                <Col md = {6} className="custom-mt-10">
                                    <div style={{fontSize:10}} className="text-danger">Masculino <span className="text-muted"><strong>({resp.M})</strong> estudiantes</span></div>
                                    <div className="progress">
                                        <div className="progress-bar" role="progressbar" aria-valuenow="70"
                                            aria-valuemin="0" aria-valuemax="100" style={{width: `${Math.round(porcentajeM)}%`, backgroundColor:"#1f2f6e"}}>
                                            {Math.round(porcentajeM)}%
                                        </div>
                                    </div>
                                </Col>
                            </Row>
            
            this.setState({
                datosC: contenido,
                datosT: <div className="custom-alert-info"><Row>
                            <Col md = {6}>
                                <div style={{fontSize:12}}>Inscritos:</div>
                                <div style={{fontSize:12, color: "000"}}><strong>({resp.Total}) estudiantes</strong></div>
                            </Col>
                            <Col md = {6}>
                                <div style={{fontSize:12}}>Capacidad de la sección:</div>
                                <div style={{fontSize:11, color: "000"}}><strong>({this.props.datos.cupos}) estudiantes</strong></div>
                            </Col>
                        </Row></div>
            })
        })
    }

    render() {
        let {datos} = this.props;
        let {datosC, datosT} = this.state;
        const styles = {
            padding: 10, fontSize: 12
        }

        const styles2 = {
            padding: 10, fontSize: 11
        }

        return (
            <tr>
                <td style={styles2}>
                    <strong className="text-primary">{datos.materia_name}</strong>
                    <div className="text-danger"> <strong>SECCION {datos.nombre}</strong></div>
                    {datosT}
                </td>
                <td style={styles}>{datosC}</td>
            </tr>
        );
    }
}
 
export default AlumnosSeccion;


// WEBPACK FOOTER //
// ./src/views/Opciones/AlumnosSeccion.jsx